import { render, staticRenderFns } from "./volunteerDetailPage.vue?vue&type=template&id=97cbe70e&scoped=true"
import script from "./volunteerDetailPage.vue?vue&type=script&lang=js"
export * from "./volunteerDetailPage.vue?vue&type=script&lang=js"
import style0 from "./volunteerDetailPage.vue?vue&type=style&index=0&id=97cbe70e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cbe70e",
  null
  
)

export default component.exports